import { service } from '@/request/server'

// 首页统计
export const total = (params) => (
  service({
    url: '/Index/index',
    method: 'GET',
    params
  })
)

// 首页病症分类
export const info = (params) => (
  service({
    url: '/Home_illness_category/info',
    method: 'GET',
    params
  })
)

// 添加/编辑首页病症分类
export const saveInfo = (params) => (
  service({
    url: '/Home_illness_category/saveInfo',
    method: 'POST',
    data: params
  })
)


